<template>
  <Modal
    class="[&>.modal-wrapper]:!max-w-[600px] desktop:[&>.modal-wrapper]:!max-w-[1150px]"
    :show-modal="showImportTemplateModal"
    @close="toggleImportTemplateModal"
  >
    <template #header>
      <TitleRegular
        class="text-center"
        :title="$t('customer.sub_nav.caas.templates')"
      />
      <TextSmall class="text-center">
        {{ $t('shared.content_generation.manage_templates') }}
      </TextSmall>
    </template>
    <template #body>
      <SectionCard>
        <Table :columns="columns">
          <CaasTableRow
            v-for="(temp, index) in templates"
            :key="index"
            :templates-table="true"
            :row-items="temp"
            :allow-edit-template="false"
            :allow-export-template="false"
            :whiteBg="index % 2 === 0"
            @editTemplate="applyTemp"
          >
            <template #applyTemplateBtn>
              <BtnSecondary
                outline
                size="sm"
                data-cy="apply_template"
                :title="$t('shared.content_generation.apply_template')"
                type="button"
                @click="applyTemp(temp)"
              />
            </template>
          </CaasTableRow>
        </Table>
        <PaginationPerPage
          v-if="pages.current"
          :pages="pages"
          @onChange="onPageChange"
          @changePerPage="onPerPageChange"
        />
      </SectionCard>
    </template>
    <template #footer>
      <BtnsWrapperVertical>
        <BtnSecondary
          :title="$t('shared.button.cancel')"
          type="button"
          @click="toggleImportTemplateModal"
        />
      </BtnsWrapperVertical>
    </template>
  </Modal>
</template>
<script setup>
import CaasTableRow from '@/components/contentGeneration/CaasTable/CaasTableRow'
import BtnSecondary from '@/components/shared/btn/BtnSecondary'
import BtnsWrapperVertical from '@/components/shared/btn/BtnsWrapperVertical'
import TextSmall from '@/components/shared/font/text/TextSmall'
import TitleRegular from '@/components/shared/font/title/TitleRegular'
import Modal from '@/components/shared/Modal'
import PaginationPerPage from '@/components/shared/pagination/PaginationPerPage'
import SectionCard from '@/components/shared/section/SectionCard'
import Table from '@/components/shared/table/Table'
import i18n from '@/i18n'
import { $cookies } from '@/main'
import { computed, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

const route = useRoute()
const router = useRouter()
const store = useStore()
const $t = i18n.t

const columns = ref([
  {
    field: 'name',
    label: $t('shared.label.name'),
    width: 150
  },
  {
    field: 'created_by',
    label: $t('shared.label.created_by'),
    width: 80
  },
  { field: 'created_at', label: $t('shared.labels.created_at'), width: 80 },
  {
    field: 'actions',
    label: '',
    width: 120
  }
])

const templates = computed(() => store.state.contentGeneration.templates)
const pages = computed(() => store.state.contentGeneration.templatesPages)
const currentTemplate = computed(
  () => store.state.contentGeneration.currentTemplate
)
const showImportTemplateModal = computed(
  () => store.state.modals.showImportTemplateModal
)

const startLoader = () => store.dispatch('loading/startLoader')
const stopLoader = () => store.dispatch('loading/stopLoader')
const getTemplates = (payload) =>
  store.dispatch('contentGeneration/getTemplates', payload)
const getTemplate = (payload) =>
  store.dispatch('contentGeneration/getTemplate', payload)
const toggleImportTemplateModal = () =>
  store.commit('modals/toggleImportTemplateModal')
const applyTemplate = (payload) =>
  store.commit('contentGeneration/applyTemplate', payload)

function onPageChange(pageNum) {
  router
    .push({
      name: 'contentGenerationV2',
      query: {
        page: pageNum,
        perPage: $cookies.get('perPage') || route.query.perPage
      }
    })
    .catch(() => {})
}

function onPerPageChange(perPage) {
  router
    .push({
      name: 'contentGenerationV2',
      query: { page: 1, perPage: perPage }
    })
    .catch(() => {})
}

watch(
  () => route.query,
  async () => {
    if (
      route.meta.baseRoute === 'contentGenerationV2' &&
      showImportTemplateModal.value
    ) {
      await getTemplates({
        currentPage: route.query.page,
        perPage: $cookies.get('perPage') || route.query.perPage
      })
    }
  },
  { deep: true }
)

async function applyTemp(temp) {
  toggleImportTemplateModal()
  startLoader()
  await getTemplate(temp.id)
  applyTemplate(currentTemplate.value)
  stopLoader()
}
</script>
